import { render, staticRenderFns } from "./ExerciseEdit.vue?vue&type=template&id=703ebeaa&scoped=true&"
import script from "./ExerciseEdit.vue?vue&type=script&lang=ts&"
export * from "./ExerciseEdit.vue?vue&type=script&lang=ts&"
import style0 from "./ExerciseEdit.vue?vue&type=style&index=0&id=703ebeaa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "703ebeaa",
  null
  
)

export default component.exports